

















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'
  import { TreeNode } from '../model/models'
  import sparqlService from '../service/SparqlService'

  @Component({
    computed:
      mapGetters([
        'ontology',
        'concept',
        'language'
      ])
  })
  export default class ClassTree extends Vue {
    initialized:boolean = false

    @Prop()
    node: TreeNode

    @Watch('node')
    watchTreeNode () {
      console.log('Treenode changed:', this.node)
    }

    onNodeClicked (event:any, node:any) {
      console.log('onNodeClick node:', node, ' event:', event)
      this.onIconClicked(event, node)
      this.gotoConcept(node.url)
    }

    onIconClicked (event:any, node:any) {
      console.log('onIconClicked node:', node, ' event:', event)
      if (!node.resolved) {
        sparqlService.getClassChildrenAsync(node)
        node.icon = 'fa fa-angle-down'
      } else {
        if (node.children.length > 0) {
          node.collapsed = !node.collapsed
          if (node.collapsed) {
            node.icon = 'fa fa-angle-right'
          } else {
            node.icon = 'fa fa-angle-down'
          }
        }
      }
    }

    gotoConcept (id:string) {
      sparqlService.gotoConcept(this.$router, id)
    }

    getLabelOrId (node:TreeNode) {
      if (node.label) {
        return node.label
      }
      return node.prefixId
    }
    @Watch('language')
    watchLanguage () {
      sparqlService.getClassTreeAsync()
    }
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ClassTree.vue